module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/transaction/shared/transaction-form/transaction-form.component.scss
// module id = ./src/app/transaction/shared/transaction-form/transaction-form.component.scss
// module chunks = main